export enum EntityType {
  Project = "PROJECT",
  Measurement = "MEASUREMENT",
  Document = "DOCUMENT",
}
